// bereitet die Daten fürs Speichern vor
import {
  Auftrag,
  Auftragsgefahrgut,
  Auftragsposition,
  AuftragZusLademittel,
} from '../../../api';
import { AuftragPositionModel } from '../../../models/AuftragPositionModel';
import {
  ABWEICHENDE_BELADESTELLE,
  ABWEICHENDE_ENTLADESTELLE,
  ABWEICHENDER_RECHNUNGSEMPFAENGER_EMPFAENGER,
  ABWEICHENDER_RECHNUNGSEMPFAENGER_VERSENDER,
  EMPFAENGER,
  NACHNAHME_EMPFAENGER,
  setAdressePayloadByTyp,
  VERSENDER,
  NEUTRALE_ABSENDERADRESSE,
} from './adresse/AdresseTypen';
import {
  appendNewTimeToDate,
  convertToLocaleDateAndTime,
  dateToIsoDate,
  utcIsoDateToString,
} from '../../../utils/date';
import { StateModel_Auftragserfassung } from '../../../redux/store';
import { ServiceModel } from '../../../models/ServiceModel';
import { WaehrungModel } from '../../../models/WaehrungModel';
import { positionDefaultRow } from './auftragspositionen/Auftragspositionen';
import { cloneDeep, toNumber } from 'lodash';
import { isObject } from '../../../utils/objectUtils';
import { ZusLademittelModel } from '../../../models/ZusLademittelModel';
import { ConfigModel } from '../../../models/ConfigModel';
import { AdresseModel } from '../../../models/AdresseModel';
import {
  DLA_ID_BEXITY_BEX,
  DLA_ID_BEXITY_RS,
  LAND_ID_AT,
} from '../../../utils/constants';
import { AuftragServiceModel } from '../../../models/AuftragServiceModel';

export const buildAuftragPayload = (
  auftragserfassung: any,
  stammWaehrungen: WaehrungModel[],
  config: ConfigModel
): Auftrag => {
  const auftragPos: Array<Auftragsposition> = [];
  const isBEXITY = config.clientKunde?.toUpperCase() === 'BEXITY';

  auftragserfassung.currentAuftragpos.forEach(
    (aufPos: AuftragPositionModel, index: number) => {
      const equal = auftragspositionIsEqual(
        cloneDeep(aufPos),
        cloneDeep(positionDefaultRow)
      );
      if (index === 0 || !equal) {
        auftragPos.push({
          warengutBezeichnung: aufPos.warengutBezeichnung,
          verpackungseinheit:
            aufPos.verpackungseinheit?.id === 0 // id 0 bedeutet nichts ist selektiert.
              ? undefined
              : aufPos.verpackungseinheit,
          verpackungAnzahl: aufPos.verpackungAnzahl,
          verpackung: aufPos.verpackung?.id
            ? {
                id: aufPos.verpackung.id,
              }
            : undefined,
          lademittelAnzahl: aufPos.lademittelAnzahl,
          lademittel: aufPos.lademittel?.id
            ? {
                id: aufPos.lademittel.id,
              }
            : undefined,
          bruttoGewicht: aufPos.bruttoGewicht ?? 0,
          lademeter: aufPos.lademeter,
          hoeheCM: aufPos.hoeheCM,
          breiteCM: aufPos.breiteCM,
          laengeCM: aufPos.laengeCM,
          volumenCBM: aufPos.volumenCBM,
          anzahlStellplaetze: aufPos.anzahlStellplaetze,
          stellplaetze: aufPos.stellplaetze,
          mitGefahrguetern: aufPos.mitGefahrguetern,
          versicherungswert: aufPos.versicherungswert,
          waehrungVersicherungswert: aufPos.waehrungVersicherungswert,
          warenwert: aufPos.warenwert,
          warenwertWaehrung: aufPos.warenwertWaehrung,
          zeichenNummer: aufPos.zeichenNummer,
          lieferschein: aufPos.lieferschein,
          auftragsgefahrgueter: aufPos.auftragsgefahrgueter
            ? removeEmptyAuftragsgefahrgueter(aufPos.auftragsgefahrgueter)
            : undefined,
        });
      }
    }
  );

  const auftragZusLdm: Array<AuftragZusLademittel> = [];
  auftragserfassung.currentZusLademittel.forEach(
    (aufZusLdm: ZusLademittelModel, index: number) => {
      if (aufZusLdm.anzahl) {
        auftragZusLdm.push({
          id: aufZusLdm.id,
          auftragId: aufZusLdm.auftragId
            ? aufZusLdm.auftragId
            : auftragserfassung.id,
          anzFolge: aufZusLdm.anzFolge,
          anzahl: +aufZusLdm.anzahl,
          lademittel: aufZusLdm.lademittel?.id
            ? {
                id: aufZusLdm.lademittel.id,
              }
            : undefined,
          eigentuemer: {
            id: aufZusLdm.eigentuemer?.id,
          },
        });
      }
    }
  );

  const auftrag: Auftrag = {
    abliefernachweisExists: false,
    absenderAdresse: setAdressePayloadByTyp(
      auftragserfassung.adressen,
      VERSENDER
    ),
    abweichendeAbholerAdresse: setAdressePayloadByTyp(
      auftragserfassung.adressen,
      ABWEICHENDE_BELADESTELLE
    ),
    abweichendeRechnungsempfaengerAdresse: setAdressePayloadByTyp(
      auftragserfassung.adressen,
      ABWEICHENDER_RECHNUNGSEMPFAENGER_EMPFAENGER
    ),
    neutralerAbsenderAdresse: setAdressePayloadByTyp(
      auftragserfassung.adressen,
      NEUTRALE_ABSENDERADRESSE
    ),
    empfaengerAdresse: setAdressePayloadByTyp(
      auftragserfassung.adressen,
      EMPFAENGER
    ),
    abweichendeEmpfaengerAdresse: setAdressePayloadByTyp(
      auftragserfassung.adressen,
      ABWEICHENDE_ENTLADESTELLE
    ),
    rechnungsempfaengerAdresse: setAdressePayloadByTyp(
      auftragserfassung.adressen,
      ABWEICHENDER_RECHNUNGSEMPFAENGER_VERSENDER
    ),
    nachnahmeempfaengerAdresse: setAdressePayloadByTyp(
      auftragserfassung.adressen,
      NACHNAHME_EMPFAENGER
    ),
    status: {
      id: 1,
    },
    sumBruttoGewicht: auftragserfassung?.auftrag?.sumBruttoGewicht ?? 0,
    sumLademittelAnzahl: auftragserfassung?.auftrag?.sumLademittelAnzahl ?? 0,
    sumVerpackungAnzahl: auftragserfassung?.auftrag?.sumVerpackungAnzahl ?? 0,
    typ: 0,
    id: undefined,

    spedeigennr:
      auftragserfassung.id && !auftragserfassung.copyId
        ? auftragserfassung?.auftrag?.spedeigennr
        : undefined,

    spedfremdnr:
      auftragserfassung.spedfremdnr !== ''
        ? auftragserfassung.absenderreferenz
        : undefined,
    empfaengerReferenz:
      auftragserfassung.empfaengerreferenz !== ''
        ? auftragserfassung.empfaengerreferenz
        : undefined,
    absenderReferenz:
      auftragserfassung.absenderreferenz !== undefined &&
      auftragserfassung.absenderreferenz !== null &&
      auftragserfassung.absenderreferenz !== '' &&
      !isBEXITY
        ? auftragserfassung.absenderreferenz.substring(0, 20)
        : undefined,
    partnerReferenz:
      auftragserfassung.partnerreferenz !== ''
        ? auftragserfassung.partnerreferenz
        : undefined,
    auftragspositionen: auftragPos,
    auftragZusLademittel: auftragZusLdm,
    datum:
      auftragserfassung.id && !auftragserfassung.copyId
        ? dateToIsoDate(new Date(auftragserfassung.datum))
        : dateToIsoDate(convertToLocaleDateAndTime(new Date())),
    abholDatumVon:
      appendNewTimeToDate(
        auftragserfassung.beladedatum,
        auftragserfassung.beladezeitVon
      ) ?? undefined,
    abholDatumBis:
      appendNewTimeToDate(
        auftragserfassung.beladedatum,
        auftragserfassung.beladezeitBis
      ) ?? undefined,
    zustellDatumVon:
      appendNewTimeToDate(
        auftragserfassung.entladedatum,
        auftragserfassung.entladezeitVon
      ) ?? undefined,
    zustellDatumBis:
      appendNewTimeToDate(
        auftragserfassung.entladedatum,
        auftragserfassung.entladezeitBis
      ) ?? undefined,
    terminkennzeichen: auftragserfassung.terminkennzeichen && {
      id: auftragserfassung.terminkennzeichen,
    },
    zustellkennzeichen: auftragserfassung.zustellkennzeichen && {
      id: auftragserfassung.zustellkennzeichen,
    },
    anlieferkennzeichen: auftragserfassung.anlieferkennzeichen && {
      id: auftragserfassung.anlieferkennzeichen,
    },
    frankatur: auftragserfassung.frankatur && {
      id: auftragserfassung.frankatur,
    },
    verkehrsart: auftragserfassung.verkehrsart && {
      id: auftragserfassung.verkehrsart,
    },
    metrokennung: auftragserfassung.metrokennung && {
      id: auftragserfassung.metrokennung,
    },
    sperrigkeit: auftragserfassung.sperrigkeit && {
      id: auftragserfassung.sperrigkeit,
    },
    iban: auftragserfassung.iban !== '' ? auftragserfassung.iban : undefined,
    bic: auftragserfassung.bic !== '' ? auftragserfassung.bic : undefined,
    nachnahmeBetrag:
      auftragserfassung.nachnahmeBetrag !== ''
        ? auftragserfassung.nachnahmeBetrag
        : undefined,
    nachnahmeWaehrung:
      auftragserfassung.nachnahmeBetrag !== ''
        ? //? stammWaehrungen.find(basiswaehrung => basiswaehrung.id === 2)
          auftragserfassung.nachnahmeWaehrung
        : undefined,
    tauschpaletteA:
      auftragserfassung.tauschpaletteA !== ''
        ? auftragserfassung.tauschpaletteA
        : undefined,
    tauschpaletteB:
      auftragserfassung.tauschpaletteB !== ''
        ? auftragserfassung.tauschpaletteB
        : undefined,
    tauschpaletteR:
      auftragserfassung.tauschpaletteR !== ''
        ? auftragserfassung.tauschpaletteR
        : undefined,
    tauschpaletteY:
      auftragserfassung.tauschpaletteY !== ''
        ? auftragserfassung.tauschpaletteY
        : undefined,
    mitGefahrguetern: getService(auftragserfassung, 'mitGefahrguetern')?.active,
    lenkeravis: getService(auftragserfassung, 'lenkeravis')?.active,
    abtragen: getService(auftragserfassung, 'abtragen')?.active,
    myDelivery: getService(auftragserfassung, 'myDelivery')?.active,
    adv3: getService(auftragserfassung, 'adv3')?.active,
    dispohinweis:
      auftragserfassung.dispohinweis !== ''
        ? auftragserfassung.dispohinweis
        : undefined,
    hinweis:
      auftragserfassung.hinweis !== '' ? auftragserfassung.hinweis : undefined,
    zollvermerk:
      auftragserfassung.zollvermerk !== ''
        ? auftragserfassung.zollvermerk
        : undefined,
    mandant: auftragserfassung.mandant,
    sumPackstueckAnzahl: auftragserfassung.sumPackstueckAnzahl ?? 0,
    abweichendeBeladung:
      (auftragserfassung.abweichendeBeladung &&
        !auftragserfassung.isNeutralerAbsenderAdresse) ??
      false,
    spotpreisnr:
      auftragserfassung.spotpreisnr !== ''
        ? auftragserfassung.spotpreisnr
        : undefined,
    erfasser: !auftragserfassung.id
      ? auftragserfassung.currentBenutzer
      : undefined,
    datumerfasst: !auftragserfassung.id
      ? dateToIsoDate(convertToLocaleDateAndTime(new Date()))
      : auftragserfassung.datumerfasst
      ? auftragserfassung.datumerfasst
      : dateToIsoDate(convertToLocaleDateAndTime(new Date())),
    datumgeaendert: auftragserfassung.id
      ? dateToIsoDate(convertToLocaleDateAndTime(new Date()))
      : undefined,
    aenderer: auftragserfassung.id
      ? auftragserfassung.currentBenutzer
      : undefined,
    auftragServices: convertServiceModelToDynamic(auftragserfassung, 0),
  };
  return auftrag;
};
const getCustomerSpecificDLA = (
  //Momentan nicht gebraucht. Wurde im Juni '23 von der Oberfläche nach hier verlagert. Stehen lassen, bis geklärt ist warum und dann evtl. wieder aktivieren.
  config: ConfigModel,
  auftragserfassung: any
) => {
  if (config.clientKunde?.toUpperCase() === 'BEXITY') {
    let versenderAdresse = auftragserfassung.adressen.find(
      (item: AdresseModel) => item.typ === VERSENDER
    );

    const abwAbholadresse = auftragserfassung.adressen.find(
      (item: AdresseModel) => item.typ === ABWEICHENDE_BELADESTELLE
    );

    const empfaengerAdresse = auftragserfassung.adressen.find(
      (item: AdresseModel) => item.typ === EMPFAENGER
    );

    if (abwAbholadresse.id) {
      versenderAdresse = abwAbholadresse;
    }

    if (
      versenderAdresse.land.id !== LAND_ID_AT ||
      empfaengerAdresse.land.id !== LAND_ID_AT
    ) {
      if (
        auftragserfassung.zustellkennzeichen ||
        auftragserfassung.anlieferkennzeichen
      ) {
        return DLA_ID_BEXITY_RS;
      } else {
        return DLA_ID_BEXITY_BEX;
      }
    } else {
      return DLA_ID_BEXITY_BEX;
    }
  }
};

const removeEmptyAuftragsgefahrgueter = (
  auftragsgefahrgueter: Auftragsgefahrgut[]
) => {
  return auftragsgefahrgueter.filter(
    (aufragsgefahrgut: Auftragsgefahrgut) =>
      aufragsgefahrgut.gefahrgutklasse.id &&
      aufragsgefahrgut.anzahl &&
      aufragsgefahrgut.verpackung.id &&
      aufragsgefahrgut.bruttoGewicht &&
      (aufragsgefahrgut.liter || aufragsgefahrgut.nettoGewicht)
  );
};

const getService = (
  auftragserfassung: StateModel_Auftragserfassung,
  attribut: string
): ServiceModel | undefined => {
  return auftragserfassung.currentServices.find(
    (service: ServiceModel) => service.attributName === attribut
  );
};

/**
 * Vergleicht auftragsposition objekte, in dem er ignoriert:
 * - das auftptNum Feld,
 * - Felder wo als Wert ein leeres String, undefined oder { elementId: 0, value: '' } (default Wert bei der Select Liste) drin steht.
 *
 * @param object1 first object
 * @param object2 second object
 * @returns {boolean} true if they are equal in values, or else false
 */
const auftragspositionIsEqual = (
  object1: { [x: string]: any },
  object2: { [x: string]: any }
): boolean => {
  Object.keys(object1)
    .filter(keyName => keyName !== 'auftptNum')
    .forEach(key =>
      object1[key] === undefined && '' && { elementId: 0, value: '' }
        ? delete object1[key]
        : {}
    );
  Object.keys(object2)
    .filter(keyName => keyName !== 'auftptNum')
    .forEach(key =>
      object2[key] === undefined && '' && { elementId: 0, value: '' }
        ? delete object2[key]
        : {}
    );

  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if (
      (areObjects && !auftragspositionIsEqual(val1, val2)) ||
      (!areObjects && val1 !== val2)
    ) {
      return false;
    }
  }

  return true;
};

export const convertServiceModelToDynamic = (
  auftragserfassung: StateModel_Auftragserfassung,
  auftrag_Id: number
): AuftragServiceModel[] => {
  const tmp = auftragserfassung.currentServices.filter(
    item => item.spez_num != undefined
  );
  const auftragServiveModel = tmp.map((item, index) => {
    let wertuebergabe = item.wert;
    if (item.typ?.toLowerCase() === 'logisch') {
      if (item.active) wertuebergabe = 'true';
      else wertuebergabe = 'false';
    } else if (item.typ?.toLowerCase() === 'datum') {
      wertuebergabe = item.wert ? utcIsoDateToString(item.wert) : '';
    }
    return {
      auftragID: auftrag_Id,
      spez_num: toNumber(item.spez_num ?? 0),
      wert: wertuebergabe ?? '',
    } as AuftragServiceModel;
  });
  return auftragServiveModel.filter(item => item.wert != 'false');
};
